<template>
    <span>
        <font-awesome-icon
            icon="play"
            fixed-width />
        <span>
            {{ $t('menu.regStart') }}
        </span>
    </span>
</template>
<script>
export default {
    name: 'MenuItemRegSummary'
}
</script>
<style lang="scss" scoped>


</style>